// extracted by mini-css-extract-plugin
export default {"map-container":"Test_map-container__2a0sj","popup-content":"Test_popup-content__qZbLP","address":"Test_address__DQ8y3","coordinates":"Test_coordinates__pdqN6"};